export default "__VITE_ASSET__Blxl80wk__"